import React from 'react';
import { useIntl } from 'react-intl';
import { compose } from 'redux';

import AddOnBoardingScreens from '../../../components/SiteAdmin/ManageProviderOnBoardingScreens/AddOnBoardingScreens';

import messages from '../../../locale/messages';
import { getOnBoardingContent } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

const EditScreen = ({ getOnBoardingContent }) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.editProviderOnBoardingScreens)}</h1>
            <AddOnBoardingScreens initialValues={getOnBoardingContent?.getOnBoardingContent?.result} />
        </div>
    );
}
export default compose(
    withQuery(getOnBoardingContent, {
        name: 'getOnBoardingContent',
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(EditScreen);
